/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmd_Go_MilestonesInputs */

const en_cmd_go_milestones = /** @type {(inputs: Cmd_Go_MilestonesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to milestones`)
};

const de_cmd_go_milestones = /** @type {(inputs: Cmd_Go_MilestonesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu den Meilensteinen`)
};

/**
* | output |
* | --- |
* | "Go to milestones" |
*
* @param {Cmd_Go_MilestonesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cmd_go_milestones = /** @type {((inputs?: Cmd_Go_MilestonesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmd_Go_MilestonesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cmd_go_milestones(inputs)
	return en_cmd_go_milestones(inputs)
});